import { Injectable } from '@angular/core';
import { isNullOrUndefined } from 'is-what';
import { DeviceStatusEnum } from '../data/enums/device-status-enum';

@Injectable({
  providedIn: 'root'
})
export class StatusClassService {

  constructor() { }

  getViewClass(line) {
    if (line.lineStatus == DeviceStatusEnum.Down || line.lineStatus == DeviceStatusEnum.ParentDown) return "text-danger";
    else if (line.lineStatus == DeviceStatusEnum.Up) return "text-success";
    //else if (line.lineStatus == DeviceStatusEnum.ParentDown) return "text-muted";
    else if (line.lineStatus == DeviceStatusEnum.Maintenance) return "text-warning";
    else return "text-muted";
  }
  getStatus(statusId) {
    if (isNullOrUndefined(statusId)) statusId = DeviceStatusEnum.Maintenance;
    if (statusId === 4) { // Check if statusId is 4 (representing "unknown")
      return "Maintenance";
    }
    const indexOfS = Object.values(DeviceStatusEnum).indexOf(statusId as unknown as DeviceStatusEnum);
 
    const key = Object.keys(DeviceStatusEnum)[indexOfS];
    return key;
    
  }
  getTextClass(line) {
    if (line.lineStatus == DeviceStatusEnum.Down || line.lineStatus == DeviceStatusEnum.ParentDown) return "danger";
    else if (line.lineStatus == DeviceStatusEnum.Up) return "success";
    //else if (line.lineStatus == DeviceStatusEnum.ParentDown) return "text-muted";
    else if (line.lineStatus == DeviceStatusEnum.Maintenance) return "warning";
    else return "text-muted";
  }


  getpairStatus(status: number) {
    if (status==1) 
      return "text-success";
    else
      return "text-danger";
  }
}
